import type { DropdownPassThroughOptions } from "primevue/dropdown";
import type { PassThrough } from "primevue/ts-helpers";

export const pt: PassThrough<DropdownPassThroughOptions> = {
  trigger: "hidden",
  input: (options: { global: { class: Array<string> } }) => {
    return `${options?.global?.class?.join(" ")} py-0`;
  },
};
